export class AgendaCopyException
{
    día_origen:any;
    día_destino:any;

} 